module.exports = __webpack_public_path__ + "img/banner2_4_jp.f62ffaaf.png";